import React from 'react';
import { currency } from '|/helpers';
import styles from './total-vehicle-price.module.css';
import { usePaymentContext } from '../../../contexts/payment';

const label = 'Total vehicle price';

const subtext =
  'Includes taxes, title and registration. May include upgrades, optional add\u2011ons, and trade\u2011in value if applicable.';

export const TotalVehiclePrice = () => {
  const {
    state: {
      paymentSummary: { totalVehiclePrice }
    }
  } = usePaymentContext();

  return (
    <div className={styles.container}>
      <div className={styles.lineItem}>
        <div className={styles.label}>{label}</div>
        <div className={styles.value}>{currency(totalVehiclePrice).replace('.00', '')}</div>
      </div>

      <div className={styles.subtext}>{subtext}</div>
    </div>
  );
};
